import { isEmpty } from "@utils/var.check";

export default {
  splitTextByNewLine(fullText) {
    return fullText.split(/\r?\n/);
  },
  splitTextByDelimiters(fullText, delimiters) {
    const splitText = fullText.match(delimiters);
    if (!isEmpty(splitText)) {
      return splitText;
    } else {
      return [fullText];
    }
  },
  getDelimiters(language) {
    switch (language) {
      case "ENGLISH":
        return /([^.?!\n]+[.?!\n\s+]*)/g;
      case "CHINESE":
        return /([^。？！…\n]+[。？！…\n\s+]*)/g;
      case "MALAY":
        return /([^.？！…\n]+[.？！…\n\s+]*)/g;
      case "TAMIL":
        return /([^.?!…\n]+[.?!…\n\s+]*)/g;
    }
  },
  getLanguage(text) {
    if (text.includes("malay")) {
      return "MALAY";
    } else if (text.includes("tamil")) {
      return "TAMIL";
    } else if (text.includes("english")) {
      return "ENGLISH";
    } else {
      return "CHINESE";
    }
  },
  getEncoding(language) {
    switch (language) {
      case "ENGLISH":
        return "EN";
      case "CHINESE":
        return "ZH";
      case "MALAY":
        return "MS";
      case "TAMIL":
        return "TA";
    }
  },
};
